// Returns the list of courses the current user is allowed to see in the admin course UI.
// Course admins are scoped to the courses they have a CourseUser row for; admin roles

import { courseSelectors, courseUserSelectors, createAppSelector } from "./base";
import { OrgCapability, hasOrgCapability, selectCurrentUserOrgRole } from "./permissions";

// see every course in the org.
export const selectAdminAccessibleCourses = createAppSelector(
  [courseSelectors.selectAll, selectCurrentUserOrgRole, courseUserSelectors.filterForCurrentUser],
  (courses, orgUserRole, currentUserCourseUsers) => {
    if (hasOrgCapability(orgUserRole, OrgCapability.CAN_AUTHOR_ORG)) {
      return courses;
    }

    const accessibleCourseIds = new Set(currentUserCourseUsers.map((cu) => cu.course_id));
    return courses.filter((course) => accessibleCourseIds.has(course.id));
  },
);
